export default __webpack_public_path__ + "static/media/truck-time-selected.d675c613.svg";